import { TASK_STATUS_LABEL, type EpcTaskStatus } from '../utils/taskStatus';

const CHIP: Record<EpcTaskStatus, string> = {
  done: 'border-emerald-200 bg-emerald-50 text-[#047857]',
  inProgress: 'border-[#aecfbe] bg-[#f6fbf8] text-[#076333]',
  slipping: 'border-amber-200 bg-amber-50 text-[#b45309]',
  notStarted: 'border-slate-200 bg-slate-50 text-slate-500',
  blocked: 'border-rose-200 bg-rose-50 text-[#be123c]',
};

export function TaskStatusChip({ status }: { status: EpcTaskStatus }) {
  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-full border px-2.5 py-1 text-[10px] font-bold uppercase tracking-wide ${CHIP[status]}`}
    >
      {TASK_STATUS_LABEL[status]}
    </span>
  );
}
